import { getErrorCode } from "tools/error";

export const CATEGORY_ALREADY_EXIST = "CATEGORY_ALREADY_EXIST";

/**
 * The 409 api-v2 raises when another category on the Show already has the
 * title. The form's own check only sees the categories it was given, so the
 * server can still refuse — that must reach the Title field, not vanish.
 */
export const isCategoryTitleTaken = (error: unknown): boolean =>
  getErrorCode(error) === CATEGORY_ALREADY_EXIST;
